import { UpdateResolver } from "@urql/exchange-graphcache";

import { DeleteUserMutationVariables } from "@tract/common/dist/graphql";

export const api_delete_user: UpdateResolver = (_, __, cache, info) => {
  const variables = info.variables as DeleteUserMutationVariables;
  cache.invalidate(`user:${variables.userId}`);
};
